
import '../../components/Home/Home.scss';

function About() {
    return (
        <>
            <nav style={{ padding: '15px', background: '#eee', marginBottom: '30px', width: '100%', height: '63px' }} aria-label="breadcrumb">
                <div className="container">
                    <ol className="breadcrumb  me-3" style={{ float: 'right' }}>
                        <li className="breadcrumb-item"><a href="/home" style={{ color: '#000' }}>Home</a></li>
                        <li className="breadcrumb-item active" aria-current="page">About</li>
                    </ol>
                </div>
            </nav>
            <section className="about-us mt-5">
                <div className="container">
                    <div className="row mt-5 ">
                        <div className="col-lg-6 col-12">
                            <div className="about me-lg-4">
                                <div className="main-heading">
                                    <h3 className="sub-title">
                                        Welcome to the superb hotels
                                    </h3>
                                    <h2 className="title">Know More About Us</h2>
                                </div>
                                <div className="content">
                                    {/* <span>The Superb Hotels offer deluxe facilities & accommodation.</span> */}
                                    <p>
                                        Superb Hotels is a premium hotel in the city of Hyderabad, offering an exceptional experience to the guests. We are committed to
                                        providing world-class accommodation to all our guests at attractive rates. Located in the heart of Hyderabad, Superb Hotels is the perfect choice for anyone looking to explore the city and still be close to the different modes of transportation. Lakdi-ka-Pul Railway Station and Khairatabad Railways Station are both located within walking distance, Superb Hotels is also accessible via the Hyderabad Metro. Numerous popular attractions in the city are also within walking distance of the Hotel due to our central location.
                                    </p>

                                    <p>
                                        We offer an assortment of rooms including Standard, Deluxe and Superb Deluxe that resonate with elegance and comfort. We also have round-the-clock room service, and 24-hour front desk support to ensure hassle-free check-in and check-out service. Among other amenities, Superb Hotel offers free wifi and a world-class in-house restaurant serving multiple mouthwatering cuisines to our guests who choose to book their stay with us.
                                    </p>
                                    <p>Our guests have had amazing experiences with us during their stays and we are dedicated to continue delivering outstanding services to all our future guests. Book your stay with us now to enjoy premium accommodation, impeccable service, and unbeatable convenience.
                                    </p>
                                </div>
                            </div>

                        </div>
                        <div className="col-lg-6 col-12">
                            <div className="row">
                                <div className="col-md-6 col-6">
                                    <div className="img-box">
                                        <img src="assets/images/about-two.png" alt="about" className='w-100' />
                                    </div>
                                </div>
                                <div className="col-md-6  col-6">
                                    <div className="img-box" style={{ marginTop: "60px" }}>
                                        <img src="assets/images/about-one.png" alt="about" className='w-100' />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default About;